import { render, staticRenderFns } from "./SelectGoal.vue?vue&type=template&id=54c36ceb&"
import script from "./SelectGoal.vue?vue&type=script&lang=js&"
export * from "./SelectGoal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports